/**
 * 言語切り替え処理（SPA） サービス
 */
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { SupportClass } from '../../components/support-class';
import { CommonLibService } from '../common-lib/common-lib.service';
import { TranslateService } from '@ngx-translate/core';
import { I18N_CONFIG } from '@conf';
import { lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { NotRetryableErrorModel } from '../../interfaces';
/**
 * 言語切り替え処理 サービス
 */
@Injectable()
export class ChangeLangService extends SupportClass {
  private _lang!: string;

  constructor(
    private _common: CommonLibService,
    private _translateService: TranslateService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    super();
  }

  destroy(): void {}

  /**
   * 初期設定
   */
  public async init() {
    await new Promise<void>((resolve) => {
      // 言語更新処理
      this.subscribeService(
        'TranslateServiceUpdate',
        this._common.aswContextStoreService.getAswContext$(),
        async (state) => {
          if (state.lang && state.lang !== this._lang) {
            await this._changeLang(state.lang);
            resolve();
          }
        }
      );
      this.subscribeService(
        'ErrorsHandlerServiceUpdate',
        this._common.errorsHandlerService.getNotRetryableError$().pipe(take(1)),
        async (errorData: NotRetryableErrorModel) => {
          if (errorData.errorType && !this._lang) {
            await this._changeLang(I18N_CONFIG.defaultLanguage);
            resolve();
          }
        }
      );
      setTimeout(async () => {
        if (!this._lang) {
          await this._changeLang(I18N_CONFIG.defaultLanguage);
          console.log('ChangeLangService.init: resolved');
          resolve();
        }
      }, 3000);
    });
  }

  /**
   * 言語切り替え処理
   *
   * @param lang 言語
   */
  private async _changeLang(lang: string): Promise<void> {
    this._lang = lang;
    // html lang属性再設定
    const documentEl: HTMLElement = this._document.documentElement;
    documentEl.lang = I18N_CONFIG.supportedLocales[lang];
    // 選択済み言語を使用中の言語に再設定する
    await lastValueFrom(this._translateService.use(lang));
  }
}
